/** @format */

export const getTimestamp = (value: string | null): number => {
    const timestamp = value ? Date.parse(value) : NaN;

    return Number.isFinite(timestamp) ? timestamp : -Infinity;
};
